import { IImageProps as FIImageProps, IImageStyles, Image as FImage, ImageFit } from '@fluentui/react';
import { forwardRef, Ref } from 'react';

import { IComponent } from '../../models/components.models';
import { useThemeStyles } from '../../utils/hooks';
import { imageStylesDefault } from './Image.styles';

export interface IImageProps extends Omit<FIImageProps, 'styles'>, IComponent<Partial<IImageStyles>> {}

export const Image = forwardRef((props: IImageProps, ref: Ref<HTMLImageElement>) => {
  const { styles, ..._fProps } = props;
  const { imageFit = ImageFit.contain } = props;
  const fProps = {
    ..._fProps,
    styles: useThemeStyles<IImageStyles>(imageStylesDefault, styles),
    imageFit,
  };
  return <FImage {...fProps} ref={ref} data-test={props['data-test'] || 'image'} />;
});
